module.exports = __webpack_public_path__ + "static/media/finPricePic.04cba49e.jpg";